import Result, { EmptyResult } from '@package/services/src/Result';

import { AuthService } from './services';
import { GetUserRequest, User } from './types';



export default class AuthInteractor {
  public constructor(private authService: AuthService) { }

  public getUser(request?: GetUserRequest): Promise<Result<User | null>> {
    return this.authService.getUser(request);
  }

  public logout(): Promise<EmptyResult> {
    return this.authService.logout();
  }
}
